export default {"src":"/_next/static/media/Room1.db306f77.svg","height":285,"width":330,"blurWidth":0,"blurHeight":0};